import { createContext } from '../../utils/createContext';
export const [SelectProvider, useSelectContext] = createContext('SelectContext');
